export default __webpack_public_path__ + "static/media/offers.19689df2.svg";